import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import FrameworkSection from "@/components/FrameworkSection";
import BusinessContext from "@/components/BusinessContext";
import DeliversGrid from "@/components/DeliversGrid";
import FeaturedDevelopment from "@/components/FeaturedDevelopment";
import TeamSection from "@/components/TeamSection";
import LeadForm from "@/components/LeadForm";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import AdminLeads from "@/components/AdminLeads";
import AdminLogin from "@/components/AdminLogin";

function LandingPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <FrameworkSection />
        <BusinessContext />
        <DeliversGrid />
        <FeaturedDevelopment />
        <TeamSection />
        <LeadForm />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/admin" element={<AdminLeads />} />
        <Route path="/admin/login" element={<AdminLogin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
